import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "#C1C1C2",
                d: "M10 1.667c4.602 0 8.333 3.73 8.333 8.333 0 4.602-3.73 8.333-8.333 8.333-4.602 0-8.333-3.73-8.333-8.333 0-4.602 3.73-8.333 8.333-8.333zm0 1.25c-3.912 0-7.083 3.171-7.083 7.083 0 3.912 3.171 7.083 7.083 7.083 3.912 0 7.083-3.171 7.083-7.083 0-3.912-3.171-7.083-7.083-7.083zm0 10.625c.316 0 .578.235.62.54l.005.085v.416c0 .346-.28.625-.625.625-.316 0-.578-.235-.62-.54l-.005-.085v-.416c0-.346.28-.625.625-.625zm0-8.75c1.555 0 2.816 1.26 2.816 2.815 0 .538-.154 1.063-.442 1.514l-.114.165-1.442 1.942c-.1.134-.163.291-.184.456l-.008.124c0 .345-.28.625-.625.625s-.625-.28-.625-.625c0-.418.118-.826.338-1.178l.1-.148 1.443-1.941c.2-.27.309-.598.309-.934 0-.864-.701-1.565-1.566-1.565-.87 0-1.492.414-1.941 1.318-.154.31-.529.435-.838.282-.309-.154-.435-.529-.281-.838.653-1.316 1.699-2.012 3.06-2.012z",
                transform: "translate(-614 -1054) translate(456 1044) translate(152 4) translate(6 6)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }